import React from 'react';
import { Search } from 'lucide-react';
import { ContentType, InterventionCategory, NewsCategory } from '../../../types/contentTypes';

interface ContentFiltersProps {
  contentType: ContentType;
  setContentType: (type: ContentType) => void;
  interventionCategory: InterventionCategory;
  setInterventionCategory: (category: InterventionCategory) => void;
  newsCategory: NewsCategory;
  setNewsCategory: (category: NewsCategory) => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const ContentFilters: React.FC<ContentFiltersProps> = ({
  contentType,
  setContentType,
  interventionCategory,
  setInterventionCategory,
  newsCategory,
  setNewsCategory,
  searchQuery,
  setSearchQuery
}) => {
  return (
    <div className="mb-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
        <h2 className="text-2xl font-bold text-secondary">Intervencije in novice</h2>
        
        {/* Search input */}
        <div className="relative w-full md:w-auto md:min-w-[300px]">
          <input
            type="text"
            placeholder="Išči..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
          />
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
        </div>
      </div>

      {/* Content type filter */}
      <div className="flex flex-wrap space-x-2 mb-4">
        <button
          onClick={() => setContentType('interventions')}
          className={`px-4 py-2 rounded-lg transition-colors ${
            contentType === 'interventions'
              ? 'bg-primary text-white'
              : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
          }`}
        >
          Intervencije
        </button>
        <button
          onClick={() => setContentType('news')}
          className={`px-4 py-2 rounded-lg transition-colors ${
            contentType === 'news'
              ? 'bg-primary text-white'
              : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
          }`}
        >
          Novice
        </button>
        <button
          onClick={() => setContentType('all')}
          className={`px-4 py-2 rounded-lg transition-colors ${
            contentType === 'all'
              ? 'bg-primary text-white'
              : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
          }`}
        >
          Vse
        </button>
      </div>

      {/* Category filters */}
      {contentType === 'interventions' && (
        <div className="flex flex-wrap gap-2 mb-6">
          <button
            onClick={() => setInterventionCategory('all')}
            className={`px-3 py-1 rounded-full text-sm transition-colors ${
              interventionCategory === 'all'
                ? 'bg-primary text-white'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            Vse kategorije
          </button>
          <button
            onClick={() => setInterventionCategory('fire')}
            className={`px-3 py-1 rounded-full text-sm transition-colors ${
              interventionCategory === 'fire'
                ? 'bg-primary text-white'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            Požari
          </button>
          <button
            onClick={() => setInterventionCategory('technical')}
            className={`px-3 py-1 rounded-full text-sm transition-colors ${
              interventionCategory === 'technical'
                ? 'bg-primary text-white'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            Tehnično reševanje
          </button>
          <button
            onClick={() => setInterventionCategory('natural')}
            className={`px-3 py-1 rounded-full text-sm transition-colors ${
              interventionCategory === 'natural'
                ? 'bg-primary text-white'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            Naravne nesreče
          </button>
          <button
            onClick={() => setInterventionCategory('other')}
            className={`px-3 py-1 rounded-full text-sm transition-colors ${
              interventionCategory === 'other'
                ? 'bg-primary text-white'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            Drugo
          </button>
        </div>
      )}

      {contentType === 'news' && (
        <div className="flex flex-wrap gap-2 mb-6">
          <button
            onClick={() => setNewsCategory('all')}
            className={`px-3 py-1 rounded-full text-sm transition-colors ${
              newsCategory === 'all'
                ? 'bg-primary text-white'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            Vse novice
          </button>
          <button
            onClick={() => setNewsCategory('event')}
            className={`px-3 py-1 rounded-full text-sm transition-colors ${
              newsCategory === 'event'
                ? 'bg-primary text-white'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            Dogodki
          </button>
          <button
            onClick={() => setNewsCategory('training')}
            className={`px-3 py-1 rounded-full text-sm transition-colors ${
              newsCategory === 'training'
                ? 'bg-primary text-white'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            Usposabljanja
          </button>
          <button
            onClick={() => setNewsCategory('announcement')}
            className={`px-3 py-1 rounded-full text-sm transition-colors ${
              newsCategory === 'announcement'
                ? 'bg-primary text-white'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            Obvestila
          </button>
        </div>
      )}
    </div>
  );
};

export default ContentFilters;